import { CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./decorations";

const SKILLS = ["Pytać i reagować", "Wyrażać opinie", "Negocjować", "Opowiadać"];

export const Problem = () => (
  <section id="o-kursie" data-testid="problem-section" className="scroll-mt-24 bg-white">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <SectionTag number="01" label="O kursie" color="bg-cyan" />
      </Reveal>
      <div className="mt-8 grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
        <div>
          <Reveal delay={0.05}>
            <h2 className="text-2xl font-extrabold leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
              Najlepsze gry na speaking dają uczniom powód, żeby się odezwać.{" "}
              <span className="text-ink/50">I coś, co naprawdę chcą powiedzieć.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-ink/75 sm:text-lg">
              Zagadka do rozwiązania, wspólna decyzja, misja do wykonania… Na tym
              kursie nauczysz się wykorzystywać AI do tworzenia gier, które angażują
              uczniów w rozmowę i pomagają ćwiczyć konkretny język.
            </p>
          </Reveal>
          <ul className="mt-6 flex flex-wrap gap-3" aria-label="Umiejętności ćwiczone w grach">
            {SKILLS.map((skill, i) => (
              <Reveal key={skill} delay={0.16 + i * 0.07}>
                <li
                  data-testid={`problem-skill-${i}`}
                  className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-white px-4 py-2 text-sm font-extrabold text-ink shadow-hard-sm"
                  style={{ transform: `rotate(${i % 2 === 0 ? -1.2 : 1.2}deg)` }}
                >
                  <span className="h-2 w-2 rotate-45 bg-magenta" aria-hidden="true" />
                  {skill}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.35}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink/75 sm:text-lg">
              Przygotujesz aktywności dopasowane do poziomu, wieku i zainteresowań
              Twojej grupy - z prostymi zasadami i przestrzenią na mówienie.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="rounded-3xl border-2 border-ink bg-cyan p-7 shadow-hard lg:rotate-1">
            <span className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-white px-3.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-ink">
              <CheckCircle2 className="h-3.5 w-3.5" aria-hidden="true" />
              W AI Speaking Games
            </span>
            <p className="mt-4 text-base font-extrabold leading-relaxed text-ink">
              Każda gra zaczyna się od celu: co Twoi uczniowie mają potrafić powiedzieć?
            </p>
            <p className="mt-3 text-base font-semibold leading-relaxed text-ink/80">
              Połączysz możliwości AI z wiedzą metodyczną, żeby tworzyć gry, w których
              uczniowie słuchają siebie nawzajem, dopytują i rozwijają wypowiedzi.
            </p>
            <p className="mt-3 text-base font-semibold leading-relaxed text-ink/80">
              Dowiesz się, jak przygotowywać scenariusze, karty ról i materiały oraz
              zapewniać wsparcie językowe, dzięki któremu również mniej pewni siebie
              uczniowie mogą włączyć się do rozmowy.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
